

module.exports = __webpack_require__.stylable.create(
    "ToggleSwitch2988178423",
    {"classes":{"root":"ToggleSwitch2988178423__root","input":"ToggleSwitch2988178423__input","track":"ToggleSwitch2988178423__track","knob":"ToggleSwitch2988178423__knob","knobIcon":"ToggleSwitch2988178423__knobIcon"},"vars":{},"stVars":{},"keyframes":{}},
    ".ToggleSwitch2988178423__root{display:inline-flex;position:relative}.ToggleSwitch2988178423__input{position:absolute;opacity:0;width:100%;height:100%;top:0;left:0;margin:0;padding:0;cursor:inherit}",
    1,
    "ToggleSwitch2988178423",
    __webpack_require__.stylable.$
);
